<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="headline">Upload </span>
      </v-card-title>

      <v-card-text class="pa-3">
        <div class="text-center">
          <FileContainer
            id="file"
            ref="cnfRef"
            icon="mdi-folder-zip-outline"
            class="mx-auto"
            style="max-width: 360px;"
            @input="onUploaded"
            @remove="remove"
          />
        </div>

        <div
          v-if="file.name"
          class="file-info mt-4 text-center"
        >
          <v-chip
            color="primary lighten-5"
            text-color="primary"
            class="mb-2"
          >
            <v-icon left>
              mdi-file
            </v-icon>
            {{ file.name }}
          </v-chip>
          <div class="text-caption grey--text">
            Ready to upload
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="px-6 pb-6 pt-0 mt-2">
        <v-spacer />
        <v-btn
          class="mr-3"
          color="error"
          @click="close"
          @click.native="close()"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          class="white--text"
          :loading="loader"
          @click="save(uploadInfo)"
        >
          <v-icon left>
            mdi-upload
          </v-icon>
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FileContainer from "@/components/utils/fileContainer";
import { failure } from "@/mixins/common";
export default {
  name: "UploadDigitoryApp",
  components: {
    FileContainer
  },
  mixins: [failure],
  data() {
    return {
      dialog: false,
      loader: false,
      uploadInfo: {},
      file: {}

    };
  },
  computed: {},

  watch: {},
  methods: {

    open() {
      this.dialog = true;
    },
    save(uploadInfo) {
      if (!this.uploadInfo) {
        return;
      }
    
      let formData = new FormData();
      formData.set(uploadInfo.key, uploadInfo.file);
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/digitoryApps/upload`;
      this.$http.post(url, formData).then(
        response => {
          this.loader = false;
          this.close();
          this.handleSuccess(response);
        },
        failure => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    close() {
      this.remove();
      this.dialog = false;
    
      this.$emit("refresh");
    },

    onUploaded(file) {
      this.file = {};
      if (file) {
        this.file = file;
        this.uploadInfo = {
          file: this.file,
          key: "file"
        };
      }
    },
    remove() {
      this.file = {};
      this.uploadInfo = {};
      this.file.name="";

  
    }
    ,
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.body.message
      });
    }
  }
};
</script>

<style scoped>

.file-info {
  transition: all 0.3s ease;
}

.v-btn--disabled {
  opacity: 0.7;
}
</style>
